import type { Field } from "../../api/types";
import type { CanvasPaperConfig } from "../PageDesigner/PageDesigner";
import { SidebarElementList } from "../SidebarElementList/SidebarElementList";
import type { StaticElementCanvas } from "../SidebarElementList/types";
import { SidebarFieldList } from "../SidebarFieldList/SidebarFieldList";
import { SidebarPaperConfig } from "../SidebarPaperConfig/SidebarPaperConfig";
import { SidebarTab } from "./components/SidebarTab/SidebarTab";

export interface SidebarProps {
  fields: Field[];
  activeSidebar: SidebarOptions;
  canvasPaperConfig: CanvasPaperConfig;
  setActiveSidebar: (sidebarOptions: SidebarOptions) => void;
  onAddField: (field: Field) => void;
  onAddElement: (type: StaticElementCanvas) => void;
  onCanvasPaperConfigUpdate: (canvasPaperConfig: CanvasPaperConfig) => void;
}

export enum SidebarOptions {
  fields = "fields",
  elements = "elements",
  settings = "settings",
}

export const Sidebar: React.FC<SidebarProps> = ({
  fields,
  activeSidebar,
  canvasPaperConfig,
  setActiveSidebar,
  onAddField,
  onAddElement,
  onCanvasPaperConfigUpdate,
}) => {
  return (
    <div className="sidebar">
      <div className="sidebar__tabs">
        <SidebarTab
          iconName="brush"
          label="Elements"
          isActive={activeSidebar === SidebarOptions.elements}
          onClick={() => setActiveSidebar(SidebarOptions.elements)}
        />

        <SidebarTab
          iconName="field"
          label="Fields"
          isActive={activeSidebar === SidebarOptions.fields}
          onClick={() => setActiveSidebar(SidebarOptions.fields)}
        />

        <SidebarTab
          iconName="settings"
          label="Settings"
          isActive={activeSidebar === SidebarOptions.settings}
          onClick={() => setActiveSidebar(SidebarOptions.settings)}
        />
      </div>

      {activeSidebar === SidebarOptions.fields && (
        <SidebarFieldList fields={fields} onClick={onAddField} />
      )}
      {activeSidebar === SidebarOptions.settings && (
        <SidebarPaperConfig
          canvasPaperConfig={canvasPaperConfig}
          onCanvasPaperConfigUpdate={onCanvasPaperConfigUpdate}
        />
      )}
      {activeSidebar === SidebarOptions.elements && (
        <SidebarElementList onClick={onAddElement} />
      )}
    </div>
  );
};
